<template>
  <div class="row mx-0">
    <div class="col-12">
      <div class="p-0 m-0 mt-4 main-title" style="font-size: 3rem">
        即時參數顯示
      </div>
      <div class="d-flex flex-wrap">
        <div
          class="d-inline-flex mt-auto p-2 ps-0 text-start"
          style="margin-top: 2rem"
        >
          <div>
            <p style="font-size: 2rem">製程</p>
            <select
              class="custom-select"
              style="
                max-width: 16rem;
                height: 3.75rem;
                line-height: 2.75rem;
                font-size: 2rem;
                border: 2px solid rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
                color: rgb(95, 95, 95);
              "
              v-model="selected"
              name="commonSelectInput"
            >
              <option disabled value="">-- 選擇製程 --</option>
              <option
                v-for="(option, index) in oper"
                :value="option.value"
                :disabled="option.value == ''"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
        <div class="mt-auto p-2">
          <button
            type="button"
            class="btn btn-secondary"
            style="
              background-color: #4b8c80;
              width: 8.5rem;
              height: 3.5rem;
              font-size: 2.25rem;
              line-height: normal;
            "
            @click="submitQuery"
          >
            確定
          </button>
        </div>
      </div>
      <div class="row mx-0">
        <div class="col-12 px-0 text-end my-2" style="font-size: 2rem">
          <span class="my-0">更新時間:</span>
          <span class="my-0">
            {{ nowTime }}
          </span>
        </div>
      </div>
      <div class="ht-work-value-div table-responsive mx-0">
        <table class="heatinstant-table table-head-theme-green">
          <thead class="sticky-thead">
            <tr>
              <th
                v-for="paramField in userSelected == 'factory_two-7'
                  ? htTwoFields
                  : htOneFields"
                style="min-width: 80px; font-size: 1.75rem; font-weight: 700"
              >
                {{ paramField.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="paramItem in heatInstantItems">
              <tr>
                <td rowspan="2" style="background-color: #fff">
                  {{ paramItem.device_name }}
                </td>
                <td style="min-width: 100px">設定值</td>
                <td v-for="setValue in paramItem.value.set">
                  {{ setValue }}
                </td>
              </tr>
              <tr style="color: #4b8c80">
                <td style="min-width: 100px">實際值</td>
                <td v-for="(actValue, act) in paramItem.value.act">
                  {{ actValue }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonTable from "@/components/commonTable.vue";
import { computed, inject, onUnmounted, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    commonTable,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const timeOutId = computed(
      () => store.getters["commonAlert/get_timeOutId"]
    );
    const oper = computed(() => store.getters["selectOptions/get_htProcess"]);

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        return await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const selected = ref("");
    const nowTime = ref("-");
    const queryCounter = ref(0);
    const userSelected = ref("");
    const path = inject("path");

    //即時參數顯示資料
    const htOneFields = [
      {
        key: "device_name",
        label: "機台",
      },
      {
        key: "param_name",
        label: "參數\n名稱",
      },
      {
        key: "quench_furn_temp1",
        label: "焠火\n1區T",
      },
      {
        key: "quench_furn_temp2",
        label: "焠火\n2區T",
      },
      {
        key: "quench_furn_temp3",
        label: "焠火\n3區T",
      },
      {
        key: "quench_furn_temp4",
        label: "焠火\n4區T",
      },
      {
        key: "quench_furn_temp5",
        label: "焠火\n5區T",
      },
      {
        key: "quench_furn_temp6",
        label: "焠火\n6區T",
      },
      {
        key: "tempering_furn_temp1",
        label: "回火\n1區T",
      },
      {
        key: "tempering_furn_temp2",
        label: "回火\n2區T",
      },
      {
        key: "tempering_furn_temp3",
        label: "回火\n3區T",
      },
      {
        key: "tempering_furn_temp4",
        label: "回火\n4區T",
      },
      {
        key: "tempering_furn_temp5",
        label: "回火\n5區T",
      },
      {
        key: "quench_tank_temp",
        label: "焠火\n槽T",
      },
      {
        key: "cln_bf_temp",
        label: "前清\n洗T",
      },
      {
        key: "cln_af_temp",
        label: "後清\n洗T",
      },
      {
        key: "cp1",
        label: "碳勢1",
      },
      {
        key: "cp2",
        label: "碳勢2",
      },
    ];
    const htTwoFields = [
      {
        key: "device_name",
        label: "機台",
        rowspan: true,
        rowspanQty: 2,
      },
      {
        key: "param_name",
        label: "參數\n名稱",
      },
      {
        key: "quench_furn_temp1",
        label: "焠火\n1區T",
      },
      {
        key: "quench_furn_temp2",
        label: "焠火\n2區T",
      },
      {
        key: "quench_furn_temp3",
        label: "焠火\n3區T",
      },
      {
        key: "quench_furn_temp4",
        label: "焠火\n4區T",
      },
      {
        key: "quench_furn_temp5",
        label: "焠火\n5區T",
      },
      {
        key: "quench_furn_temp6",
        label: "焠火\n6區T",
      },
      {
        key: "quench_furn_temp7",
        label: "焠火\n7區T",
      },
      {
        key: "tempering_furn_temp1",
        label: "回火\n1區T",
      },
      {
        key: "tempering_furn_temp2",
        label: "回火\n2區T",
      },
      {
        key: "tempering_furn_temp3",
        label: "回火\n3區T",
      },
      {
        key: "tempering_furn_temp4",
        label: "回火\n4區T",
      },
      {
        key: "tempering_furn_temp5",
        label: "回火\n5區T",
      },
      {
        key: "quench_tank_temp",
        label: "焠火\n槽T",
      },
      {
        key: "dryer_cln_bf_temp",
        label: "前烘\n乾T",
      },
      {
        key: "cln_bf_temp",
        label: "前清\n洗T",
      },
      {
        key: "cln_af_temp",
        label: "後清\n洗T",
      },
      {
        key: "cp1",
        label: "碳勢1",
      },
      {
        key: "cp2",
        label: "碳勢2",
      },
      {
        key: "weight",
        label: "設定重量",
      },
      {
        key: "time_interval",
        label: "間隔時間",
      },
      {
        key: "slow_weight",
        label: "慢速設定重量",
      },
      {
        key: "speed",
        label: "設定速度",
      },
    ];
    const heatInstantItems = ref([]);

    const setSessionItems = () => {
      sessionStorage.setItem(
        "mes-heatInstant-userSelected",
        userSelected.value
      );
    };
    window.addEventListener("beforeunload", setSessionItems);

    const getNowTime = () => {
      let Today = new Date();
      nowTime.value =
        Today.getFullYear() +
        "-" +
        String(Today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(Today.getDate()).padStart(2, "0") +
        " " +
        String(Today.getHours()).padStart(2, "0") +
        ":" +
        String(Today.getMinutes()).padStart(2, "0") +
        ":" +
        String(Today.getSeconds()).padStart(2, "0");
    };

    const submitQuery = () => {
      userSelected.value = selected.value;
      heatInstantItems.value = [];
      getMachineData();
    };
    const clearTimer = () => {
      var highestIntervalId = setInterval(";");
      for (var i = 0; i < highestIntervalId; i++) {
        if (i == timeOutId.value) {
          continue;
        }
        //清除所有計時資料
        clearInterval(i);
      }
    };
    const getMachineData = async () => {
      clearTimer();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      params["methods"] = "GET";
      params["whichFunction"] = "instantQuery";
      params["oper"] = userSelected.value;

      try {
        await methods.axiosAction(params);
        let result = axiosResult.value;
        if (!result) throw new Error("axiosResult.value is undefined");

        let result_data = result.QueryTableData;
        if (path.value !== result.page) return;

        if (result.Response == "ok") {
          if (result.oper == userSelected.value) {
            heatInstantItems.value = result_data;
          }
        }

        queryCounter.value++;
        getNowTime();

        setTimeout(() => getMachineData(), 1000);
      } catch (error) {
        console.error("Error in getMachineData:", error);
        // 可以在這裡決定是否要繼續遞迴
        setTimeout(() => getMachineData(), 5000); // 如果發生錯誤，5 秒後重試
      }

      // methods.axiosAction(params).then(() => {
      //   let result = axiosResult.value;
      //   let result_data = result.QueryTableData;
      //   if (path.value != result.page) {
      //     return;
      //   }
      //   if (result.Response == "ok") {
      //     if (result.oper == userSelected.value) {
      //       heatInstantItems.value = result_data;
      //     }
      //   }

      //   result = null;
      //   result_data = null;
      //   queryCounter.value++;
      //   getNowTime();
      //   setTimeout(function () {
      //     getMachineData();
      //   }, 1000);
      // });
    };

    // 紀錄查詢次數，超過1500次重新整理
    watch(queryCounter, (newValue) => {
      if (newValue > 1500) {
        window.location.reload();
      }
    });

    setTimeout(() => {
      //重設製程及組別、清空機台與明細資料
      clearTimer();
      //session資料
      const mesHeatInstantUserSelected = sessionStorage.getItem(
        "mes-heatInstant-userSelected"
      );

      sessionStorage.removeItem("mes-heatInstant-userSelected");
      if (mesHeatInstantUserSelected != null) {
        selected.value = mesHeatInstantUserSelected;
        userSelected.value = mesHeatInstantUserSelected;
        getMachineData();
      }
    }, 0);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
      clearTimer();
    });

    return {
      oper,
      selected,
      nowTime,
      userSelected,
      htOneFields,
      htTwoFields,
      heatInstantItems,
      submitQuery,
    };
  },
};
</script>

<style>
.heatinstant-table {
  width: 100%;
  white-space: pre-line;
  border: 1px solid #000;
  font-size: 1.75rem;
}
.heatinstant-table thead tr:first-child th {
  border: 2px solid #000 !important;
}
.heatinstant-table tr:nth-child(2n-1) {
  background-color: #f0f0f0;
}
.heatinstant-table td,
.heatinstant-table th {
  border: 2px solid #000;
  font-weight: 700;
}
</style>
